





































































import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { Role } from '@/data/models/role.model';
import { CrudService } from '@/data/services/crud.service';
import { Search } from '@/data/models/search.model';
import { Page } from '@/data/models/page.model';

@Component({
	components: {
		ValidationObserver,
		ValidationProvider
	}
})
export default class NewEditRuolo extends Vue {
	@Prop() ruolo?: Role;
	@Inject('CrudService') ruoloCrudService!: CrudService<Role>;

	newRuolo: Role;

	constructor() {
		super();
		this.newRuolo = new Role();
	}

	loadRuolo(id: number) {
		const search = new Search('role');
		search.addSimpleFilter('id', id);
		this.ruoloCrudService
			.searchEntities(Role, 'role', search, new Page(1))
			.then(results => {
				this.newRuolo = results[0];
			});
	}

	submit() {
		this.$emit('submit', this.newRuolo);
	}

	beforeMount() {
		if (this.ruolo) {
			if (this.ruolo.id) {
				this.loadRuolo(this.ruolo.id);
			} else {
				this.newRuolo = new Role();
			}
		}
	}
}
